import React from "react";
import { Avatar, Box } from "@material-ui/core";
import { HFlex, Text } from "shared";
import { useHcp } from "api/hooks/useHCPs";

const getInitials = (name: string) => {
  const words = name.split(" ").filter(Boolean);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};

const Summary: React.VFC = () => {
  const { data: hcp } = useHcp();
  if (!hcp) return null;

  return (
    <HFlex gap={2} alignItems="center" mb={2}>
      <Avatar>{getInitials(hcp.name)}</Avatar>
      <Box overflow="auto">
        <Text heading bold nowrap mb={0}>
          {hcp.name}
        </Text>
      </Box>
    </HFlex>
  );
};

export default Summary;
